export default __webpack_public_path__ + "navigation-camera-bearing-smoothing-enabled-1200-dbdbba64bfe8d22e226cd4b896c15edb.png";